<div fxLayout="row wrap" mat-dialog-content>
  <div class="loader" *ngIf="loading">
    <mat-spinner color="accent"></mat-spinner>
  </div>
  <div
    fxFlex.gt-sm="40"
    fxFlex.lt-sm="100"
    style="padding: 16px"
    [style.background]="data.panelBackground"
    [style.color]="data.panelForeground"
  >
    <img [src]="data.sourceImage" />
    <h2 *ngIf="!isMobile">{{ data.titleText }}</h2>
    <p *ngIf="!isMobile" [innerHtml]="data.infoText"></p>
  </div>
  <div fxFlex.gt-sm="60" fxFlex.lt-sm="100" style="padding: 16px">
    <div *ngIf="success" class="success">
      <mat-icon>check_circle</mat-icon>
      <h3>Email has been sent!</h3>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit(form)" *ngIf="!success">
      <mat-form-field [appearance]="data.formFieldAppearance">
        <mat-label>ID Number</mat-label>
        <mat-hint
          >Entering your ID number will assist us in resolving your query
          faster.</mat-hint
        >
        <input matInput formControlName="idNumber" autocomplete="off" />
      </mat-form-field>
      <mat-form-field [appearance]="data.formFieldAppearance">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" autocomplete="off" />
        <mat-hint>Please enter your first and last name.</mat-hint>
        <mat-error *ngIf="form.controls.name?.errors?.['required']"
          >Your name is <strong>required</strong>.</mat-error
        >
        <mat-error *ngIf="form.controls.name?.errors?.['pattern']"
          >Only letters are allowed.</mat-error
        >
      </mat-form-field>
      <mat-form-field [appearance]="data.formFieldAppearance">
        <mat-label>Cell Number</mat-label>
        <mat-hint>Please enter your cell number.</mat-hint>
        <input matInput formControlName="cellNumber" autocomplete="off" />
        <mat-error *ngIf="form.controls.cellNumber?.errors?.['required']"
          >Your cell number is <strong>required</strong>.</mat-error
        >
        <mat-error *ngIf="form.controls.cellNumber?.errors?.['pattern']"
          >Only numeric characters are allowed.</mat-error
        >
        <mat-error *ngIf="form.controls.cellNumber?.errors?.['minlength']"
          >Input needs to be at least 10 characters.</mat-error
        >
      </mat-form-field>
      <mat-form-field [appearance]="data.formFieldAppearance">
        <mat-label>Email Address</mat-label>
        <mat-hint>Please enter a valid email address.</mat-hint>
        <input matInput formControlName="emailAddress" autocomplete="off" />
        <mat-error *ngIf="form.controls.emailAddress?.errors?.['required']"
          >Your email address is <strong>required</strong>.</mat-error
        >
        <mat-error *ngIf="form.controls.emailAddress?.errors?.['email']"
          >Invalid email address.</mat-error
        >
      </mat-form-field>
      <mat-form-field [appearance]="data.formFieldAppearance">
        <mat-label>Reason</mat-label>
        <mat-select formControlName="reason">
          <mat-option [value]="item" *ngFor="let item of data.topicOptions">{{
            item
          }}</mat-option>
        </mat-select>
        <mat-error>A reason is <strong>required</strong>.</mat-error>
        <mat-hint>Please select a reason for this email submission.</mat-hint>
      </mat-form-field>
      <mat-form-field [appearance]="data.formFieldAppearance">
        <mat-label>Message</mat-label>
        <textarea
          matInput
          formControlName="message"
          autocomplete="off"
        ></textarea>
        <mat-error>Your message is <strong>required</strong>.</mat-error>
        <mat-hint>Let us know how we can assist you.</mat-hint>
      </mat-form-field>
      <div *ngIf="data.allowFileUploads">
        <br />
        <button
          (click)="attachmentsInputLabel.click()"
          mat-raised-button
          [style.background]="data.btnBackground"
          [style.color]="data.btnForeground"
          type="button"
        >
          <mat-icon>attachment</mat-icon>&nbsp;Attach
        </button>
        <ng-container *ngIf="files">
          &nbsp;<span
            >{{ files.length }} file{{
              files.length > 1 ? "s" : ""
            }}
            attached</span
          >
        </ng-container>
        <label #attachmentsInputLabel for="attachmentsInput" hidden></label>
        <input
          type="file"
          multiple
          hidden
          id="attachmentsInput"
          (change)="fileChange($event)"
        />
        <br />
      </div>
      <div style="text-align: right">
        <button mat-button type="button" mat-dialog-close>Cancel</button>
        <button
          mat-raised-button
          [style.background]="data.btnBackground"
          [style.color]="data.btnForeground"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
